import React, { memo, useMemo, useCallback } from 'react'
import Chip from '@material-ui/core/Chip'
import { makeStyles } from '@material-ui/styles'
import { useTranslation } from 'react-i18next'
import * as _ from 'lodash'

import styles from './styles'
import { ECompanyActionTypes } from 'models'
import Loading from 'components/loading'
import { StoreValue } from 'store'

const useStyles = makeStyles(styles)

const AvailableLocationsView: React.FunctionComponent<{
	loading: boolean
	handleSearchChange: Function
	pristine?: boolean
	storeDispatch: any
	offices: any
	headquarters: any
	headquartersOfficeType?: boolean
}> = ({
	pristine,
	loading,
	handleSearchChange,
	storeDispatch,
	offices,
	headquarters,
	headquartersOfficeType,
}) => {
	const classes = useStyles()
	const { t } = useTranslation()
	let availableLocations: any = headquartersOfficeType
		? headquarters.available
		: offices.available
	let selected: any = headquartersOfficeType
		? headquarters.selected
		: offices.selected
	const selectedLocations = useMemo(() => selected.map((item: any) => item), [
		selected,
	])
	const select: any = useCallback(
		(location: any) => () => {
			if (headquartersOfficeType) {
				storeDispatch({
					type: ECompanyActionTypes.setSelectHeadquarters,
					headquarters: { location },
				})
			} else {
				storeDispatch({
					type: ECompanyActionTypes.setSelectOffices,
					offices: { location },
				})
			}
			handleSearchChange('')
		},
		[storeDispatch, handleSearchChange, headquartersOfficeType],
	)

	const checkIfExist = useCallback(
		(location: any) => {
			const existInList = _.find(
				selectedLocations,
				(item: any) => item.id === location.id,
			)
			return existInList === undefined
		},
		[selectedLocations],
	)

	return (
		<div className={(!loading && pristine && availableLocations.length === 0) || (!loading && availableLocations.length >0)? classes.availableLocationsContainer : ''}>
			{!loading &&
				availableLocations &&
				availableLocations.map((item: any) => (
					<Chip
						key={item.id}
						variant="outlined"
						label={item.name}
						className={classes.chip}
						clickable={checkIfExist(item)}
						size={'small'}
						onClick={!checkIfExist(item) ? null : select(item)}
					/>
				))}
			{loading && <Loading size={48} style={{ margin: '20px auto' }} />}
			{!loading && pristine && availableLocations.length === 0 && (
				<div>{t('No locations found')}</div>
			)}
		</div>
	)
}
const AvailableLocations = memo((props: any) => (
	<StoreValue
		keys={[
			'company.offices|offices',
			'company.headquarters|headquarters',
			'storeDispatch',
		]}
	>
		<AvailableLocationsView {...props} />
	</StoreValue>
))

export default AvailableLocations
